import { Section, SectionInfo, Word } from '../../types'

export const getEmptySections = (sections: Section[]) => {
  const emptySections = sections.reduce((acc: SectionInfo[], section: Section, index: number) => {
    if (section.lines.length) {
      return acc
    }
    const prevSection = index > 0 ? sections[index - 1] : null
    const nextSection = index + 1 < sections.length ? sections[index + 1] : null
    return [...acc, { prevPart: prevSection, startPart: section, endPart: nextSection }]
  }, [])

  return emptySections
}
const guaranteeSectionTimes = (sections: Section[]) => {
  sections.forEach((section) => {
    if (section.time === null) {
      let startTime = 0
      if (section.lines.length) {
        const firstLine = section.lines[0]
        if (firstLine.words.length) {
          startTime = firstLine.words[0].time || 0
        }
      }
      section.time = startTime
    }
  })
}
const analyzeLRC = (sections: Section[], trackDuration: number) => {
  guaranteeSectionTimes(sections)
  const emptySections: SectionInfo[] = getEmptySections(sections)
  let lastStart = -1
  let emptyAirtime = 0

  emptySections.forEach(({ prevPart, startPart, endPart }) => {
    let startTime = startPart.time || 0
    if (startTime === 0 && prevPart) {
      if (prevPart.lines.length) {
        const lastline = prevPart.lines[prevPart.lines.length - 1]
        if (lastline.words.length) {
          const lastWord = lastline.words[lastline.words.length - 1]
          if (lastWord.time) {
            startTime = lastWord.time
            startPart.time = startTime
          }
        }
      }
    }
    if (startTime <= lastStart) {
      console.log('ignoring out-of-order empty section start', startPart)
      return
    }
    const referenceEndTime = endPart ? endPart.time : trackDuration
    const endTime = referenceEndTime !== null ? referenceEndTime : trackDuration
    const partLength = Math.round((endTime - startTime) * 1000) / 1000 // round to milliseconds
    emptyAirtime += partLength
    lastStart = startTime
  })
  // TODO: also check for space between last timed word and end of track, or even last timed word of any section
  // and start time of next section
  return emptyAirtime
}

export const analyzeDensity = (sections: Section[], trackDuration: number) => {
  console.log('analyzingDensity')
  const pointDensityAt = (word: Word, epsilon: number) => {
    const { lineIndex, time } = word
  }
}
export default analyzeLRC
